import { generateUUID } from "../../shared/services/utils";
import type { ContactDetails } from "../models/tq1-vessel-details.models";

function createBlankEmailContact(): ContactDetails {
  return {
    id: "",
    contactId: generateUUID(),
    communicationType: "Email",
    provider: "N/A",
    prefix: "",
    details: "",
    location: "N/A",
    preferred: false,
  };
}

export function promoteOrInsertFirstEmailContact(contacts: ContactDetails[]): ContactDetails[] {
  if (contacts.length === 0) return [createBlankEmailContact()];

  const rows = contacts.map((contact) => ({ ...contact }));
  const emailIndex = rows.findIndex(
    ({ communicationType }) =>
      String(communicationType ?? "")
        .trim()
        .toLowerCase() === "email",
  );

  if (emailIndex >= 0) {
    const [emailContact] = rows.splice(emailIndex, 1);
    return [{ ...emailContact, communicationType: "Email" }, ...rows];
  }

  if (!String(rows[0].communicationType ?? "").trim()) {
    rows[0] = { ...rows[0], communicationType: "Email", provider: "N/A", location: "N/A" };
    return rows;
  }

  return [createBlankEmailContact(), ...rows];
}
